import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { KudosDto } from '../../../types'
import { KudosIconIndicator } from '../../../modules/kudos/components/KudosIconIndicator'
import BackgroundBox from '../BackgroundBox'
import PerFlexRow from '../FlexRow'
import PerText from '../Text'
import { computeFullname } from '../../../shared/nameDisplayPreferencesUtil'
import { KudosDetailsModal } from '../KudosDetailsModal/KudosDetailsModal'
import { getKudosColor } from '../../../shared/kudosUtil'

export interface KudosCardProps {
  kudos: KudosDto
  nameDisplayPreference: string
}

export const KudosCard: FC<KudosCardProps> = ({ kudos, nameDisplayPreference }) => {
  const { t } = useTranslation()

  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <BackgroundBox r>
        <PerFlexRow direction="column" justify="space-between" className="fullHeight">
          <PerFlexRow direction="column">
            <PerFlexRow align="middle" justify="space-between" mb="xs">
              <KudosIconIndicator kudosType={kudos.type} />
              <a
                onClick={(e) => {
                  e.preventDefault()
                  setIsModalOpen(true)
                }}
                style={{
                  fontSize: '12px',
                  color: '#05cbce',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                {t('kudos.viewDetails')}
              </a>
            </PerFlexRow>

            <PerText className="ellipsis--line-3">{kudos.description}</PerText>
          </PerFlexRow>

          {kudos.author && (
            <PerFlexRow justify="end" mt="s">
              <PerFlexRow direction="column" align="bottom">
                <PerText fontSize="s" fontWeight="bold" color={getKudosColor(kudos.type)}>
                  {computeFullname(nameDisplayPreference, kudos.author.firstName, kudos.author.lastName)}
                </PerText>
                {kudos.author.companyName && (
                  <PerText fontSize="xs" mt="xxxs" color="secondary">
                    {kudos.author.companyName}
                  </PerText>
                )}
              </PerFlexRow>
            </PerFlexRow>
          )}
        </PerFlexRow>
      </BackgroundBox>

      <KudosDetailsModal visible={isModalOpen} onClose={() => setIsModalOpen(false)} kudos={kudos} />
    </>
  )
}

export default KudosCard
